import type { TextFieldProps } from "@mui/material";
import type { JSX } from "react";
import type { Attribute } from "../sign-up-request";
import { Autocomplete, TextField } from "@mui/material";
import { useObservable } from "ecce-react";


const STATES: Record<string, string> = {
	"AL": "Alabama",
	"AK": "Alaska",
	"AS": "American Samoa",
	"AZ": "Arizona",
	"AR": "Arkansas",
	"CA": "California",
	"CO": "Colorado",
	"CT": "Connecticut",
	"DE": "Delaware",
	"DC": "District Of Columbia",
	"FL": "Florida",
	"GA": "Georgia",
	"GU": "Guam",
	"HI": "Hawaii",
	"ID": "Idaho",
	"IL": "Illinois",
	"IN": "Indiana",
	"IA": "Iowa",
	"KS": "Kansas",
	"KY": "Kentucky",
	"LA": "Louisiana",
	"ME": "Maine",
	"_": "Marshall Islands",
	"MD": "Maryland",
	"MA": "Massachusetts",
	"MI": "Michigan",
	"__": "Micronesia",
	"MN": "Minnesota",
	"MS": "Mississippi",
	"MO": "Missouri",
	"MT": "Montana",
	"NE": "Nebraska",
	"NV": "Nevada",
	"NH": "New Hampshire",
	"NJ": "New Jersey",
	"NM": "New Mexico",
	"NY": "New York",
	"NC": "North Carolina",
	"ND": "North Dakota",
	"MP": "Northern Mariana Islands",
	"OH": "Ohio",
	"OK": "Oklahoma",
	"OR": "Oregon",
	"___": "Palau",
	"PA": "Pennsylvania",
	"PR": "Puerto Rico",
	"RI": "Rhode Island",
	"SC": "South Carolina",
	"SD": "South Dakota",
	"TN": "Tennessee",
	"TX": "Texas",
	"UT": "Utah",
	"VT": "Vermont",
	"VI": "Virgin Islands",
	"VA": "Virginia",
	"WA": "Washington",
	"WV": "West Virginia",
	"WI": "Wisconsin",
	"WY": "Wyoming",
};

export const isUsState = (x: string): boolean => Object.values(STATES).includes(x);
export const usStateFromCode = (x: string): string | null => STATES[x] ?? null;

type UsStateSelect = Omit<TextFieldProps, "onChange" | "value" | "select"> & {
	attribute: Attribute<string>;
};

export const UsStateSelect = (p: UsStateSelect): JSX.Element => {
	const { attribute, ...textFieldProps } = p;
	useObservable(attribute);

	return (
		<Autocomplete
			options={ Object.values(STATES) }
			renderInput={ props => (
				<TextField { ...textFieldProps } { ...props } size="small" required/>
			) }
			value={ attribute.value }
			onChange={ (ev, value) => attribute.value = value ?? "" }
			disablePortal
		/>
	);
};
